export default "__VITE_ASSET__B3rZ$Sze__"